/** A device's display name; an endpoint with no reported name shows its ID. */
export function deviceDisplayName(device: {
  name: string | null;
  hardwareDeviceId: string | null;
  machineIds: string[];
}): string {
  return (
    device.name ??
    device.hardwareDeviceId ??
    device.machineIds[0] ??
    'Unknown endpoint'
  );
}

/** The ID shown for a device: its hardware ID, else its one endpoint ID. */
export function deviceShownId(device: {
  hardwareDeviceId: string | null;
  machineIds: string[];
}): string | null {
  return device.hardwareDeviceId ?? device.machineIds[0] ?? null;
}

/**
 * A person's display label: name, else email, else the OS account they signed
 * in with (an Unattributed person has nothing else), else "Unattributed".
 */
export function personLabel(person: {
  name: string | null;
  email: string | null;
  osAccount?: string | null;
}): string {
  return person.name || person.email || person.osAccount || 'Unattributed';
}

/** Up to two initials for an avatar: "Alice Cohen" → "AC", "trainee01" → "T". */
export function personInitials(label: string): string {
  const words = label
    .replace(/@.*$/, '')
    .split(/[\s._\\-]+/)
    .filter(Boolean);
  const letters = words
    .slice(0, 2)
    .map(word => word.charAt(0).toUpperCase())
    .join('');
  return letters || '?';
}
